import React from "react";
import { Modal } from "@arco-design/web-react";

// MUI Dialog(+Title/Content/Actions) -> Arco Modal. The render-prop API and
// onSave behavior are unchanged; `open` maps to Modal's `visible`, and the
// Cancel/Archive buttons become the Modal footer via onCancel/onOk.
export default function ArchiveCampaignDialog({ ids, render, onSave }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    onSave && onSave();
    handleClose();
  };

  return (
    <div>
      {render(handleClickOpen)}
      <Modal
        visible={open}
        onCancel={handleClose}
        onOk={handleSave}
        title="Delete Campaign"
        okText="Archive"
        cancelText="Cancel"
      >
        Are you sure you want to archive {ids.length} campaign
        {ids.length > 1 && "s"}?
      </Modal>
    </div>
  );
}
